// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Uavc","validationTips":"StatementDescriptor_validationTips__ck4oZ"};